function auctionPriceTitle (product, isOwner, loggedIn) {
  switch (product?.auction?.status) {
    case 'editing':
    case 'under_review':
    case 'published':
      return 'start_price'
    case 'running': {
      if (product?.auction?.hasBids) {
        if (product?.auction?.maxBidPrice === product?.auction?.currentPrice) {
          return 'maximum_high_bid_reached'
        } else if (isOwner) {
          return 'current_highest_bid'
        } else {
          return 'current_price'
        }
      } else if (product?.auction?.startPrice) {
        return 'start_price'
      } else if (loggedIn) {
        return 'no_bid_yet'
      } else {
        return 'current_price'
      }
    }

    case 'failed':
    case 'failed_na':
    case 'acpt_late_offer':
    case 'recd_late_offer':

      if (product?.auction?.hasBids) {
        return 'last_bid'
      } else {
        return 'start_price'
      }

    case 'sold':
    case 'renegotiation':
    case 'archived':
      return 'last_bid'
    default:
      return ''
  }
}

function biddingAdviserChance (value, targetPrice) {
  if (parseInt(value) >= targetPrice * 0.9) {
    return 'Hohe Chance'
  }
  return 'Niedrige Chance'
}

function biddingAdviserColor (value, targetPrice) {
  if (parseInt(value) >= targetPrice * 0.9) {
    return 'green'
  }
  return 'orange'
}

export default {
  auctionPriceTitle,
  biddingAdviserChance,
  biddingAdviserColor
}
